<script>
import { mapActions } from "vuex";

export default {
  name: "HeatmapExample",
  data: function () {
    return {
      chartOptions: {
        dataLabels: {
          enabled: true,
        },
        chart: {
          toolbar: {
            show: false,
          },
        },
        xaxis: {
          categories: [
            1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19,
          ]
        },
        tooltip: {
          custom: function ({ seriesIndex, dataPointIndex, w }) {
            var data =
              w.globals.initialSeries[seriesIndex].data[dataPointIndex];
            return '<div class="tooltip_settings">' + data.element + "</div>";
          },
        },
        yaxis: {
          labels: {
            show: true,
            align: "left",
            style: {
              colors: [],
              fontSize: "15px",
              fontFamily: "Roboto",
              fontWeight: 400,
              cssClass: "custom-apexcharts-yaxis-label",
            },
            offsetX: 5,
            offsetY: 0,
            rotate: 0,
          },
        },
        title: {
          text: this.language === 'tr' ? 'SKA Alt Hedef Hizalama (SKA Hizalama Anket Sonucu)' : "SDG Sub Target Alignment (SDG Alignment Survey Result)",
          align: "center",
          style: {
            fontSize: "20px",
            heigth: "100px",
            fontFamily: "Muli', Arial, sans-serif",
          },
        },
        colors: [
          "#E6243C",
          "#D19F2A",
          "#2D9A47",
          "#C22033",
          "#EF412A",
          "#00ADD8",
          "#FDB714",
          "#8F1838",
          "#F36E24",
          "#E01A83",
          "#F99D25",
          "#CD8B2A",
          "#48773C",
          "#007DBB",
          "#40AE49",
          "#00558A",
          "#1A3668",
        ],
        heatmap: {
          radius: 2,
          distributed: true,
        },
      },
      series: [],
    };
  },

  created() {
    this.getNames();
  },
  props: {
    selectedSurveyID: null,
    language: {
      type: String,
      default: localStorage.getItem('lang') || 'en',
    }
  },
  methods: {
    ...mapActions("results", ["su1SubColumn"]),
    getNames() {
      let params = {
        company_id: this.$user.company_id,
        is_deleted: false,
        su1_survey_id: this.selectedSurveyID,
        language: this.language,
      };
      this.su1SubColumn(params)
        .then((response) => {
          response.data.series.forEach((item) => {
            this.series.push(item);
          });
        })
        .catch(({ response }) => {
          this.$toast.open({
            message: this.$parseResMessage(response.data.messageName),
            type: "error",
            duration: 5000,
            dismissible: true,
          });
        });
    },
    generateData(count, yrange) {
      var i = 0;
      var series = [];
      while (i < count) {
        var x = (i + 1).toString();
        var y =
          Math.floor(Math.random() * (yrange.max - yrange.min + 1)) +
          yrange.min;
        series.push({
          x: x,
          y: y,
        });
        i++;
      }
      return series;
    },
  },
};
</script>

<template>
  <apex-chart width="100%" type="heatmap" :options="chartOptions" :series="series"></apex-chart>
</template>



<style>
.tooltip_settings {
  font-family: "Roboto";
  font-size: 16px;
}

.custom-apexcharts-yaxis-label {
  transform: translateX(1.25%) !important;
}
</style>